import { render, staticRenderFns } from "./CustomerProductDiscountInfo.vue?vue&type=template&id=43922824&"
import script from "./CustomerProductDiscountInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerProductDiscountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports